import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title as UiTitle } from '@/shared/uikit/Title';
import { Tabs } from '@/shared/uikitV2/antd/Tabs';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  // grid-template-rows: 148px calc(100% - 148px - 92px) 92px;
  grid-template-rows: auto 1fr 92px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px 24px 0;
  border-bottom: 1px solid ${COLORS.systemDark100};
`;

export const Body = styled.div`
  padding: 24px;
  overflow: scroll;
`;

export const Actions = styled.div`
  padding-inline: 24px;
  border-top: 1px solid ${COLORS.systemDark100};
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Title = styled(UiTitle)`
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.systemDark200};
`;

export const TabsStyled = styled(Tabs)`
  &&&.ant-tabs {
    margin-top: 24px;
    height: 32px;
    overflow: hidden;
  }

  &&& .ant-tabs-ink-bar {
    height: 1px;
    background: ${COLORS.systemSky200};
  }

  &&& .ant-tabs-nav-list {
    height: 32px;
  }

  &&& .ant-tabs-tab {
    margin: 0;
    pading: 0;
    width: 146px;
    justify-content: center;
  }

  &&& .ant-tabs-tab ant-tabs-nav-list .ant-tabs-tab + .ant-tabs-tab {
    marging-left: 0 !important;
  }
`;
